// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3eccc011","453":"d9487b26","455":"2f17975b","977":"cfbda82a"}[chunkId] + ".chunk.js";
};